import { render, staticRenderFns } from "./OilShxto.vue?vue&type=template&id=39ef73de&scoped=true&"
import script from "./OilShxto.vue?vue&type=script&lang=js&"
export * from "./OilShxto.vue?vue&type=script&lang=js&"
import style0 from "./OilShxto.vue?vue&type=style&index=0&id=39ef73de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ef73de",
  null
  
)

export default component.exports